// extracted by mini-css-extract-plugin
export default {"wrapper":"Uy-z","viewport":"Vy-z","container":"Wy-z","slide":"Xy-z"};